export default {
  TITLE: 'INNOVATORS CAREER',
  LABEL: {
    FOR_ENGINEER: 'エンジニア',
  },
};
